import * as actionTypes from '../actions/types';
import { updateObject } from '../../constants/utility';

const initialState = {
    isLoading: false,
    isComplete: null,
    error: null,
    data: null,
    columnName: '',
    columnOrder: 'asc',
    filter: {},
};

const paymentsStart = (state) =>
    updateObject(state, {
        isLoading: true,
        isComplete: false,
        error: null,
        columnName: '',
        columnOrder: 'asc',
    });

const paymentsSuccess = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: true,
        error: null,
        data: action.data.payments,
    });

const paymentsFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: null,
        error: action.error,
        data: null,
    });

const tableSortValues = (state, action) =>
    updateObject(state, {
        columnOrder: action.data.columnOrder,
        columnName: action.data.columnName,
    });
const tableFilter = (state, action) =>
    updateObject(state, {
        filter: action.data,
    });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PAYMENTS_START:
            return paymentsStart(state);
        case actionTypes.PAYMENTS_SUCCESS:
            return paymentsSuccess(state, action);
        case actionTypes.PAYMENTS_FAIL:
            return paymentsFail(state, action);
        case actionTypes.SORT_VALUES:
            return tableSortValues(state, action);
        case actionTypes.TABLE_FILTER:
            return tableFilter(state, action);
        default:
            return state;
    }
};

export default reducer;
